const PROCESSED_HISTORY_STATUSES = ['approved', 'rejected'];

/**
 * @param {{ addedAt?: string, updateAt?: string } | null | undefined} entry
 * @returns {number}
 */
const getHistorySortTime = (entry) => {
    if (!entry) {
        return 0;
    }

    const timestamp = entry.addedAt || entry.updateAt;
    return timestamp ? new Date(timestamp).getTime() : 0;
};

/**
 * @param {Array<{ status?: string, addedAt?: string, updateAt?: string }>} [history]
 * @returns {Array<{ status?: string, addedAt?: string, updateAt?: string }>}
 */
export const sortHistoryChronologically = (history = []) => (
    [...history].sort((a, b) => getHistorySortTime(a) - getHistorySortTime(b))
);

/**
 * @param {{ status?: string } | null | undefined} entry
 * @returns {boolean}
 */
export const isProcessedHistoryEntry = entry => (
    Boolean(entry && PROCESSED_HISTORY_STATUSES.includes(entry.status))
);

/**
 * fifo
 * @param {Array<{ status?: string, addedAt?: string, updateAt?: string }>} [history]
 * @returns {object | undefined}
 */
export const getFirstPendingHistoryEntry = (history = []) => (
    sortHistoryChronologically(history).find(entry => !isProcessedHistoryEntry(entry))
);



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/common/historyUtils.js